<template>
   <div class="teachable-review">
      <Rating @saveRating="updateRating" />
      <CommentModal
         :open="commentOpen"
         @saveComment="updateComment"
         @close="closeComment"
      />
   </div>
</template>

<script setup lang="ts">
import toastMessages from "~/data/content/toast-messages.json";

const route = useRoute();
const { review, setRating, updateTeachableReview } = useTeachable();
const { addToast } = useToast();
const { on } = useEventBus();

// REFS ========================
const commentOpen = ref<boolean>(false);

// METHODS ========================
const closeComment = (wComment: boolean = false) => {
   commentOpen.value = false;
   if (wComment) {
      addToast(toastMessages.addComment as Toast);
   }
};

const updateReview = async (
   rating: number = 0,
   reviewText: string | null = null,
) => {
   try {
      await updateTeachableReview({
         slug: String(route.params.slug),
         data: { rating, review: reviewText },
      });
   } catch {
      // plugin's catcher already surfaced the error UX (toast/modal/redirect)
   }
};

const updateRating = async (rating: number) => {
   console.log("Saving rating:", rating);

   await updateReview(rating);
   setRating(rating);
   addToast({
      ...(toastMessages.addRating as Toast),
      isToastButton: true,
      toastButtonText: "Add a Comment",
      callback: () => (commentOpen.value = true),
   });
};

const updateComment = (comment: string) => {
   review.value.review = comment;
   updateReview(review.value.rating, comment);
   closeComment(true);
};

// LIFECYCLE ========================
onBeforeMount(() => {
   // getTeachableReview(route.params.slug);
});
</script>

<style lang="scss">
@import "~/assets/scss/teachable/teachable-review";
</style>
